import * as React from "react";
import {Link} from "react-router-dom";
import { WarningBanner } from "./WarningBanner";

export class CoronaBanner extends React.Component<{}> {

    public render() {
        const showBanner: boolean = this.shouldShowCoronaBanner();
        if (showBanner) {
            const content: React.ReactNode = (
                <>
                    <Link to="/dashboard/corona"
                          id="coronaSupport"
                          aria-label="Here is how we will support you during the coronavirus covid 19">
                        Here's how we will support you
                    </Link>{' '}
                    during the coronavirus outbreak
                </>
            )

            return (
                <WarningBanner wording={content}/>
            );
        } else {
            return (<></>);
        }

    }

    private shouldShowCoronaBanner(): boolean {
        return process.env.REACT_APP_CORONA_BANNER_ENABLED ? JSON.parse(process.env.REACT_APP_CORONA_BANNER_ENABLED) : false;
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/CoronaBanner.tsx